module.exports = __webpack_public_path__ + "static/img/2_1_1.cd48bf59.jpg";